import type { SchemaBuilderFormContextValue } from "./schema-builder-form.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "SchemaBuilderFormContext",
  providerName: "SchemaBuilderFormProvider",
};

export const SchemaBuilderFormContext =
  createContext<SchemaBuilderFormContextValue | null>(null);

export const useSchemaBuilderFormContext = () => {
  const contextValue = useContext(SchemaBuilderFormContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
